import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import { manageDisableScrolling } from '../../ducks/ui.duck';
import routeConfiguration from '../../routeConfiguration';
import { getClientData, setClientData } from '../../util/clientData';
import useAppSelector from '../../util/hooks/useAppSelector';
import { FormattedMessage } from '../../util/reactIntl';
import { createResourceLocatorString } from '../../util/routes';
import Modal from '../Modal/Modal';

const VerifyPhoneNumberModal = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUser = useAppSelector((state) => state.user.currentUser);

  const onManageDisableScrolling = (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling));

  const currentUserNeedPhoneVerification =
    !currentUser?.attributes?.profile?.privateData?.phoneNumberVerification?.valid;
  const currentUserHasSeenPhoneNumberVerificationModal = getClientData(
    'vansite.phoneNumberVerificationModalShown'
  );

  const showVerifyPhoneNumberModal =
    currentUser &&
    currentUserNeedPhoneVerification &&
    !currentUserHasSeenPhoneNumberVerificationModal;
  const [openModal, setOpenModal] = useState(showVerifyPhoneNumberModal);

  const handleClose = () => {
    setClientData('vansite.phoneNumberVerificationModalShown', true, moment().add(1, 'days'));
    setOpenModal(false);
  };

  const handleGoToAccountSettings = () => {
    navigate(
      createResourceLocatorString('ContactSettingsPage', routeConfiguration(), {}, {}, intl.locale)
    );
    setOpenModal(false);
    handleClose();
  };

  return (
    <Modal
      id="VerifyPhoneNumberModal"
      isOpen={openModal}
      onClose={handleClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <Stack py={4} spacing={4}>
        <Typography component="p" variant="h4">
          <FormattedMessage id="Page.verifyPhoneNumberModal.title" />
        </Typography>
        <Typography variant="body1">
          <FormattedMessage id="Page.verifyPhoneNumberModal.description" />
        </Typography>
        <Button color="secondary" onClick={handleGoToAccountSettings} variant="contained">
          <FormattedMessage id="Page.verifyPhoneNumberModal.ok" />
        </Button>
      </Stack>
    </Modal>
  );
};

export default VerifyPhoneNumberModal;
